<div tuiCardLarge tuiSurface="elevated">

    <div class="row">
        <h2>Suivi du patient</h2>
    </div>

    @if (patient && patient.interventionList) {
    <div class="row">
        <div class="col col-12">
            <app-intervention-list-timeline [interventionList]="interventionListFiltree()" />
        </div>
    </div>

    <div class="row">
        <div class="col col-12">
            <app-intervention-list [interventionList]="patient.interventionList.data"
                [format]="activite ?? patient!.tableauDeBord?.activite" />
        </div>
    </div>
    } @else {
    <div class="row">
        <div class="col col-12">
            <app-intervention-list-timeline />
        </div>
    </div>

    <div class="row">
        <div class="col col-12">
            <app-intervention-list />
        </div>
    </div>
    }
</div>